export const LOGAIA_SVG_ICONS = [
  {
    iconName: 'upload',
    filename: 'Picto_Logaia__Exporter.svg',
  },
  {
    iconName: 'affectation-transaction',
    filename: 'Picto_Logaia__AffectationTransaction.svg',
  },
  { iconName: 'LienBanque', filename: 'Picto_Logaia__AjouterBanques.svg' },
  { iconName: 'cycle', filename: 'Picto_Logaia__Balance-par-cycle.svg' },
  { iconName: 'AttentionRouge', filename: 'Picto_Logaia__AttentionRouge.svg' },
  { iconName: 'FicheDossier', filename: 'Picto_Logaia__FicheDossier.svg' },
  { iconName: 'Email', filename: 'Picto_Logaia__Email.svg' },
  { iconName: 'AttentionJaune', filename: 'Picto_Logaia__AttentionJaune.svg' },
  {
    iconName: 'calculRecherche',
    filename: 'Picto_Logaia__CalculRecherche.svg',
  },
  {
    iconName: 'en_cours',
    filename: 'Picto_Logaia__EnCours.svg',
  },
  {
    iconName: 'en_cours_jaune',
    filename: 'Picto_Logaia__EnCoursJaune.svg',
  },
  {
    iconName: 'en_cours_orange',
    filename: 'Picto_Logaia__EnCoursOrange.svg',
  },
  {
    iconName: 'emprunt',
    filename: 'Picto_Logaia__Emprunt.svg',
  },
  {
    iconName: 'rafraichir',
    filename: 'Picto_Logaia__Rafraichir.svg',
  },
  {
    iconName: 'calculee',
    filename: 'Picto_Logaia__Calculee.svg',
  },
  {
    iconName: 'poubelle',
    filename: 'Picto_Logaia__Poubelle.svg',
  },
  {
    iconName: 'sauvegarder',
    filename: 'Picto_Logaia__Sauvegarder.svg',
  },
  {
    iconName: 'plus',
    filename: 'Picto_Logaia__Plus.svg',
  },
  {
    iconName: 'suivi-depots',
    filename: 'Picto_Logaia__SuiviDepots.svg',
  },
  {
    iconName: 'tresorerie',
    filename: 'Pictos_Logaia_Individuel__Tresorerie.svg',
  },
  {
    iconName: 'PDF',
    filename: 'Pictos_Logaia_Individuel__PDF.svg',
  },
  {
    iconName: 'home',
    filename: 'Picto_Logaia__Home.svg',
  },
  {
    iconName: 'deployed_code_account',
    filename: 'Picto_Logaia__BalanceFournisseur2.svg',
  },
  {
    iconName: 'declaration',
    filename: 'Picto_Logaia__Declarations.svg',
  },
  {
    iconName: 'account_box',
    filename: 'Picto_Logaia__BalanceClient2.svg',
  },
  {
    iconName: 'immobilisation',
    filename: 'Picto_Logaia__Immobilisation.svg',
  },
  {
    iconName: 'archives',
    filename: 'Picto_Logaia__Archives.svg',
  },
  {
    iconName: 'recherche',
    filename: 'Picto_Logaia__Recherche.svg',
  },
  {
    iconName: 'centralisateur',
    filename: 'Picto_Logaia__Centralisateur.svg',
  },
  {
    iconName: 'calendrier',
    filename: 'Picto_Logaia__Calendrier.svg',
  },
  {
    iconName: 'valid',
    filename: 'Picto_Logaia__Valide.svg',
  },
  {
    iconName: 'acceptee',
    filename: 'Picto_Logaia__Accepte.svg',
  },
  {
    iconName: 'rejetee',
    filename: 'Picto_Logaia__Rejete.svg',
  },
  {
    iconName: 'transfert',
    filename: 'Picto_Logaia__Transferer.svg',
  },
  { iconName: 'revision', filename: 'Pictos_Logaia_Individuel__Révision.svg' },
  { iconName: 'filter', filename: 'Picto_Logaia__Filtrer.svg' },
  {
    iconName: 'balance-fournisseur',
    filename: 'Picto_Logaia__BalanceFournisseur.svg',
  },
  {
    iconName: 'balance-generale',
    filename: 'Picto_Logaia__BalanceGénérale.svg',
  },
  {
    iconName: 'dossier-permanent',
    filename: 'Picto_Logaia__DossierPermanent.svg',
  },
  {
    iconName: 'lettrage',
    filename: 'Pictos_Logaia_Individuel__Lettrage.svg',
  },
  {
    iconName: 'import-factures',
    filename: 'Picto_Logaia__ImportFactures.svg',
  },
  {
    iconName: 'modifier',
    filename: 'Picto_Logaia__Modifier.svg',
  },
  {
    iconName: 'grand-livre',
    filename: 'Picto_Logaia__Grand-livre.svg',
  },
  {
    iconName: 'delettrage',
    filename: 'Picto_Logaia__Delettrage.svg',
  },
  {
    iconName: 'lettrage_auto',
    filename: 'Picto_Logaia__LettrageAuto.svg',
  },
  {
    iconName: 'saisie',
    filename: 'Picto_Logaia__Saisie.svg',
  },
  {
    iconName: 'individuel_dossier',
    filename: 'Pictos_Logaia_Individuel_Dossier.svg',
  },
  {
    iconName: 'mot_de_passe',
    filename: 'Picto_Logaia__Mot-de-passe.svg',
  },
  {
    iconName: 'deconnexion',
    filename: 'Picto_Logaia__Deconnexion.svg',
  },
  {
    iconName: 'fiscal',
    filename: 'Picto_Logaia__Fiscal.svg',
  },
  {
    iconName: 'prelevement',
    filename: 'Picto_Logaia__Prelevement.svg',
  },
  {
    iconName: 'paiement',
    filename: 'Picto_Logaia__Paiement.svg',
  },
  {
    iconName: 'banque',
    filename: 'Picto_Logaia__Banque.svg',
  },
  {
    iconName: 'plan-comptable',
    filename: 'Picto_Logaia__Plan-comptable.svg',
  },
  {
    iconName: 'bonhomme',
    filename: 'Picto_Logaia__Bonhomme.svg',
  },
  {
    iconName: 'etats_financiers',
    filename: 'Picto_Logaia__EtatFinancier.svg',
  },
  {
    iconName: 'outil',
    filename: 'Picto_Logaia__Outil.svg',
  },
  {
    iconName: 'check',
    filename: 'Picto_Logaia__Check.svg',
  },
  {
    iconName: 'annuler',
    filename: 'Picto_Logaia__Annuler.svg',
  },
  {
    iconName: 'piecejointe',
    filename: 'Picto_Logaia__Piecejointe.svg',
  },
  {
    iconName: 'note',
    filename: 'Picto_Logaia__Note.svg',
  },
  {
    iconName: 'fact',
    filename: 'FACT.svg',
  },
  {
    iconName: 'gestion-interne',
    filename: 'Picto_Logaia__Gestion-interne.svg',
  },
  {
    iconName: 'sepa',
    filename: 'SEPA.svg',
  },
  {
    iconName: 'visibility',
    filename: 'visibility.svg',
  },
  {
    iconName: 've',
    filename: 'Picto_Logaia__VE.svg',
  },
  {
    iconName: 'devis',
    filename: 'DEVIS.svg',
  },
  {
    iconName: 'avoir',
    filename: 'AVOIR.svg',
  },
];
